import React, { useState } from "react";
import { AppBar, Toolbar, Box, Typography, Stack, Grid, useMediaQuery } from "@mui/material";

export default function Navbar() {

    const isXLDesktop = useMediaQuery('(min-width:1920px)');
    const isLGDesktop = useMediaQuery('(min-width:1400px) and (max-width:1919px)');
    const fontSize = isXLDesktop ? "1.5rem" : isLGDesktop ? "1.4rem" : "1.2rem";
    const [hover, setHover] = useState(false);

    return (
        <AppBar
            position="fixed"
            elevation={0}

            sx={{
                background: "transparent",
                boxShadow: "none",
                zIndex: 100,
                paddingTop: "30px",
                marginX: "12.5%",
                width: "75%",
            }}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={8}
            >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 4,
                            paddingX: 5,
                            paddingY: 1.5,
                            borderRadius: "50px",
                            background:
                                "linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 100%)",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                            width: "fit-content",
                            backdropFilter: "blur(10px)",
                        }}
                    >
                        {/* LOGO */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    fontWeight: 600, // Grassetto all'hover
                                },
                                width: 165
                            }}
                        >
                            { hover ? (
                                <img
                                    onMouseEnter={() => setHover(true)}
                                    onMouseLeave={() => setHover(false)}
                                    onClick={() => {
                                        const el = document.getElementById("title");
                                        if (el) {
                                            el.scrollIntoView({ behavior: "smooth" });
                                        }
                                    }}
                                    src="/assets/LogoAzzurroHover.svg" // ⬅️ sostituisci con il tuo percorso
                                    alt="Logo Ginnastica Posturale"
                                    style={{ height: 55, cursor: 'pointer' }}
                                />
                            ) : (
                                <img
                                    onClick={() => {
                                        const el = document.getElementById("title");
                                        if (el) {
                                            el.scrollIntoView({ behavior: "smooth" });
                                        }
                                    }}
                                    onMouseEnter={() => setHover(true)}
                                    onMouseLeave={() => setHover(false)}
                                    src="/assets/LogoAzzurro.svg" // ⬅️ sostituisci con il tuo percorso
                                    alt="Logo Ginnastica Posturale"
                                    style={{ height: 55 }}
                                />
                            )}
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 4,
                            paddingX: 4,
                            paddingY: 1.5,
                            borderRadius: "50px",
                            background:
                                "linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.1) 100%)",
                            boxShadow: "0px 4px 24px -1px #00000026",
                            backdropFilter: "blur(10px)",
                            height: 55,
                            width: "100%",
                            WebkitBackdropFilter: "blur(20px) brightness(100%)",
                        }}
                    >

                        {/* MENU ITEMS */}
                        <Stack direction="row" spacing={4} sx={{ 
                            justifyContent: "space-between", width: "100%", paddingX: 4,
                            alignItems: "center" }}>
                            {[
                                { label: "mi presento", target: "presentazione" },
                                { label: "cosa faremo", target: "cosa-faremo" },
                                { label: "quando rivolgersi a me", target: "quando-rivolgersi" },
                                { label: "contattami", target: "contatti" },
                            ].map(
                                (item, i) => (
                                    <Typography
                                        key={i}
                                        //variant="body1"
                                        fontSize={fontSize}
                                        sx={{
                                            color: "#2F4B5B",
                                            fontFamily: "Barlow, sans-serif",
                                            fontWeight: 400,
                                            cursor: "pointer",
                                            transition: "all 0.3s ease",
                                            "&:hover": {
                                                fontWeight: 600, // Grassetto all'hover
                                            },
                                            whiteSpace: "nowrap",
                                        }}
                                        onClick={() => {
                                            const el = document.getElementById(item.target);
                                            if (el) {
                                                el.scrollIntoView({ behavior: "smooth" });
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                )
                            )}
                        </Stack>
                    </Box>
            </Stack>
        </AppBar>
    );
}


